<template>
  <v-row wrap class="justify-center">
    <v-col
      cols="12"
      sm="12"
      md="6"
      lg="4"
      v-for="testimonial in testimonials"
      :key="testimonial.name"
    >
      <v-card class="pa-2 rounded-xl" style="height:100%; border-bottom: 5px solid #082543; ">
        <v-avatar size="60" class="justify-center ml-5 mt-n7" color="#082543">
          <v-icon large color="white" v-text="testimonial.icon" />
        </v-avatar>
        <v-card-text>
          <div class="body-1" v-text="testimonial.text" />
          <v-row class="mt-4" align="stretch" justify="space-between">
            <v-col cols="4" class="justify-center align-center">
              <v-avatar style="width:100%; height:100%">
                <v-img :src="testimonial.avatar" aspect-ratio="1" contain/>
              </v-avatar>
            </v-col>
            <v-col cols="8" align-self="center">
                  <div class="body-1" v-text="testimonial.name" />
                  <div class="body-1" v-text="testimonial.role" />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      testimonials: [
        {
          name: "Team Open Minds",
          icon: "format_quote",
          avatar: "/tom.png",
          text:
            "Jetlight Studio is a good example of what a group of motivated people can achieve.",
          role: "Scientific club at Oran 1 University"
        },
        {
          name: "Algerian Game Developers Associations",
          icon: "format_quote",
          avatar: "/AGDA.png",
          text:
            "A good team with impressive projects and a big ambition.",
          role: "Algerian association"
        },
        {
          name: "UmiShopDZ",
          icon: "format_quote",
          avatar: "/Umishop.png",
          text:
            "Their products are beautiful, easy to use and with amazing prices.",
          role: "Goodies shop"
        },
      ]
    };
  }
};
</script>